/** @jsx jsx */
/* eslint-disable react/jsx-props-no-spreading */
import { jsx, Heading } from 'theme-ui'

export const SmallHeading = ({ text, ...props }) => (
  <Heading as="h1" variant="smallheading" mx={5} my={3} {...props}>
    {text}
  </Heading>
)
